import { render, staticRenderFns } from "./MNewsList.vue?vue&type=template&id=5cfae65d&scoped=true&"
import script from "./MNewsList.vue?vue&type=script&lang=ts&"
export * from "./MNewsList.vue?vue&type=script&lang=ts&"
import style0 from "./MNewsList.vue?vue&type=style&index=0&id=5cfae65d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfae65d",
  null
  
)

export default component.exports